import React from "react";
import { Link } from "react-router-dom";
import { Card, CardMedia, CardContent, CardActions, Typography, IconButton, useTheme, useMediaQuery, Box } from "@mui/material";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";

const Product = ({ product, setSelectedProduct, onAddToCart }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleAddToCart = () => onAddToCart(product.ProductId, 1);

  const handleSetSelected = () => {
    setSelectedProduct(product);
  };

  let imageUrl = process.env.REACT_APP_API_HOST + product.PrimaryImageUrl;

  return (
    <Link to={"/products/productdetails"} onClick={handleSetSelected} style={{ textDecoration: "none" }}>
      <Card
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          transition: "transform 0.15s ease-in-out",
          "&:hover": {
            transform: "scale(1.02)"
          }
        }}
      >
        <CardMedia
          component="img"
          image={imageUrl}
          alt={product.ProductName}
          sx={{
            height: isMobile ? 180 : 250,
            objectFit: "contain",
            p: 1
          }}
        />
        <CardContent sx={{ flexGrow: 1, p: isMobile ? 1 : 2 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
            <Typography
              variant={isMobile ? "subtitle1" : "h6"}
              component="h2"
              sx={{
                fontWeight: "medium",
                fontSize: isMobile ? "0.875rem" : "1.25rem"
              }}
            >
              {product.ProductName}
            </Typography>
            <Typography
              variant={isMobile ? "subtitle1" : "h6"}
              component="h2"
              sx={{
                fontWeight: "bold",
                fontSize: isMobile ? "0.875rem" : "1.25rem"
              }}
            >
              ${product.Price}
            </Typography>
          </Box>
          <Typography
            variant={isMobile ? "body2" : "body1"}
            color="text.secondary"
            sx={{
              display: isMobile ? "-webkit-box" : "block",
              WebkitLineClamp: isMobile ? 2 : "none",
              WebkitBoxOrient: isMobile ? "vertical" : "inline",
              overflow: isMobile ? "hidden" : "visible",
              fontSize: isMobile ? "0.75rem" : "0.875rem",
              minHeight: isMobile ? "auto" : "3rem"
            }}
            dangerouslySetInnerHTML={{ __html: product.Description }}
          />
        </CardContent>

        <CardActions sx={{ p: isMobile ? 0.5 : 1, mt: "auto" }}>
          <IconButton aria-label="Add to Cart" onClick={handleAddToCart} size={isMobile ? "small" : "medium"}>
            <AddShoppingCartIcon fontSize={isMobile ? "small" : "medium"} />
          </IconButton>
        </CardActions>
      </Card>
    </Link>
  );
};

export default Product;
